import MaskedInput from 'react-text-mask';
import React from 'react';

function cnpjMask () {
    return [ /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/ ];
}

// TODO: fix last digit
export function CnpjInput (props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput {...other} mask={cnpjMask} showMask keepCharPositions guide ref={ref => inputRef(ref ? ref.inputElement : null)} />
    );
}
